import React from 'react';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import { Tooltip } from '@material-ui/core';

export const HelpUserMachine = () => {


    const selectIconIes = (ies) => {

        switch (ies) {
            case 0:
                return (
                    <Tooltip title="Sin Registro" aria-label="right-end">
                        <RemoveCircleIcon style={{ color: "#c1c1c1", marginRight: "2%" }} />
                    </Tooltip>
                );
            case 1:
                return (
                    <Tooltip title="Saludable" aria-label="right-end">
                        <RadioButtonCheckedIcon style={{ color: "#2bb673", fontSize: 30, marginRight: "2%" }} />
                    </Tooltip>
                );
            case 2:
                return (
                    <Tooltip title="Margen de Mejora" aria-label="right-end">
                        <RemoveCircleIcon style={{ color: "#fcd704", fontSize: 30, marginRight: "2%" }} />
                    </Tooltip>
                );
            default:
                return (
                    <Tooltip title="Accion Requerida" aria-label="right-end">
                        <RemoveCircleIcon fontSize="large" style={{ color: "#ec1f26", marginRight: "2%" }} />
                    </Tooltip >
                );
        }

    }


    return {
        selectIconIes
    };


}